import {
  Component,
  Input,
} from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
} from '@angular/forms';
import { CustomSelectOption } from 'src/app/core/interfaces/custom-select-option';
import { Commodity } from 'src/app/core/models/commodity';
import { CommodityService } from 'src/app/core/services/general/commodity.service';
import { WarehouseTransactionService } from 'src/app/core/services/general/warehouse-transaction.service';

@Component({
  selector: 'app-batch-number-input',
  templateUrl: './batch-number-input.component.html',
  styleUrls: ['./batch-number-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: BatchNumberInputComponent,
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: BatchNumberInputComponent,
    },
  ],
})
export class BatchNumberInputComponent {
  @Input()
  title = "Search Batch Number...";

  @Input()
  isDisabled = false;

  public value?: string;
  public localValue?: CustomSelectOption;

  public batchNumbersList: Array<CustomSelectOption> = [];

  constructor(
    private warehouseTransactionService: WarehouseTransactionService,
  ) {
    this.warehouseTransactionService
      .getBatchNumbers()
      .subscribe((res: Array<string>) => {
        this.batchNumbersList = res.map((el) => {
          return {
            name: el,
            value: el,
          }
        });
        this.writeValue(this.value);
      });
  }

  ngOnInit(): void {
  }

  onChange = (val: string | undefined) => {
  };

  onTouched = () => { };

  touched = false;
  disabled = false;

  writeValue(val?: string) {
    this.value = val;
    if (this.value != undefined || this.value != null) {
      this.localValue = this.batchNumbersList.filter((el) => el.value == val)[0];
    }
  }

  onValueChange(val?: CustomSelectOption) {
    this.value = val?.value;
    this.onChange(this.value);
    this.writeValue(this.value);
  }


  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return null;
  }
}
